import { ChangeEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Root } from "../../state/types";
import { updateQrText } from "../../state/mainSlice";
import { InputAdornment, TextField, MenuItem, Select, SelectChangeEvent, Box } from "@mui/material";
import { Phone } from "@mui/icons-material";

import countryCodeData from "./country-codes.json"; // JSON file with name, dial_code, and code

interface Props {
  record(): void
}


const PhoneInput = ({ record }: Props) => {
    const dispatch = useDispatch();
    const value = useSelector((state: Root) => state.qrData.qrText);
    const [countryCode, setCountryCode] = useState("+1");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [customCountryCode, setCustomCountryCode] = useState("");

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const number = e.target.value.trim();
        setPhoneNumber(number);
        const telLink = number ? `tel:${countryCode}${number}` : "";
        dispatch(updateQrText(telLink));
    };

    const onCountryCodeChange = (e: SelectChangeEvent<string>) => {
        const newCode = e.target.value;
        if (newCode === "custom") {
            setCountryCode(customCountryCode);
        } else {
            setCountryCode(newCode);
        }
        const telLink = phoneNumber ? `tel:${newCode}${phoneNumber}` : "";
        dispatch(updateQrText(telLink));
    };

    const onCustomCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newCode = e.target.value.trim();
        setCustomCountryCode(newCode);
        setCountryCode(newCode);
        const telLink = phoneNumber ? `tel:${newCode}${phoneNumber}` : "";
        dispatch(updateQrText(telLink));
    }

    const onBlur = (event: any) => {
      record();
    }

    return (
        <Box display="flex" flexDirection="column" gap={2} width="100%">
            <Select
              value={countryCode}
              onChange={onCountryCodeChange}
              displayEmpty
              variant="outlined"
              fullWidth
            >
              {countryCodeData.map(({ name, dial_code }) => (
                <MenuItem key={dial_code} value={dial_code}>
                  {`${name} (${dial_code})`}
                </MenuItem>
              ))}
              <MenuItem value="custom">Custom</MenuItem>
            </Select>
            {countryCode === "custom" && (
                <TextField
                  variant="outlined"
                  placeholder="Custom Code"
                  value={customCountryCode}
                  onChange={onCustomCodeChange}
                  fullWidth
                />
            )}
            <TextField
              variant="outlined"
              value={phoneNumber}
              onChange={onChange}
              placeholder="Enter phone number"
              fullWidth
              onBlur={onBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone color="primary" />
                  </InputAdornment>
                ),
              }}
            />
        </Box>
    );
};

export default PhoneInput;
